export default {
  PUBLIC_URL: import.meta.env.VITE_PUBLIC_URL || '',
  VAPID_PUBLIC_KEY: import.meta.env.VITE_VAPID_PUBLIC_KEY || '',
  VAULT_ENDPOINT: (import.meta.env.VITE_VAULT_ENDPOINT || '').replace(/\/$/, ''),
}
